import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.regexp.split";
import { addLeadingZero } from "./date-helpers";
/**
 *
 * @param {string} timeString
 * @returns
 */

export function parseTimeString(timeString) {
  if (typeof timeString !== 'string') {
    return [0, 0, 0, 0];
  }

  return timeString.split(':').map(function (el) {
    return +el;
  }).map(function (el) {
    return Number.isNaN(el) ? 0 : el;
  });
}
/**
 * Returns now-Date object with entered time
 * @param {string} timeString - time string in format hh:mm:ss
 */

export function convertTimeStringToDate(timeString) {
  var output = new Date();
  var parsedString = parseTimeString(timeString).slice(0, 3);
  output.setHours.apply(output, _toConsumableArray(parsedString).concat([0]));
  return output;
}
/**
 * Converts Date object to string in format hh:mm:ss
 * @param {Date} date
 */

export function convertDateToHHMMSS(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  return "".concat(addLeadingZero(hours), ":").concat(addLeadingZero(minutes), ":").concat(addLeadingZero(seconds));
}
/**
 * Returns now-Date object with entered hour and 0 minutes and seconds
 * @param {string|Date} timeString - time string in format hh:mm:ss
 */

export function getStartOfHour(timeString) {
  if (typeof timeString === 'string') {
    var _output = new Date();

    var parsedString = parseTimeString(timeString);

    _output.setHours(parsedString[0], 0, 0, 0);

    return _output;
  }

  var oldHours = timeString.getHours();
  var output = new Date(+timeString);
  output.setHours(oldHours, 0, 0, 0);
  return output;
}
/**
 * Returns now-Date object with entered hour and 59 minutes and seconds and 999 ms
 * @param {string|Date} timeString - time string in format hh:mm:ss
 */

export function getEndOfHour(timeString) {
  if (typeof timeString === 'string') {
    var _output2 = new Date();

    var parsedString = parseTimeString(timeString);

    _output2.setHours(parsedString[0], 59, 59, 999);

    return _output2;
  }

  var oldHours = timeString.getHours();
  var output = new Date(+timeString);
  output.setHours(oldHours, 59, 59, 999);
  return output;
}
/**
 * Adds hours to Date object
 * @param {Date} date - date object
 * @param {number} hoursToAdd - number of hours to add
 */

export function addHours(date, hoursToAdd) {
  var oldHours = date.getHours();
  var output = new Date(+date);
  output.setHours(oldHours + hoursToAdd);
  return output;
}
/**
 * Adds minutes to Date object
 * @param {Date} date - date object
 * @param {number} minutesToAdd - number of minutes to add
 */

export function addMinutes(date, minutesToAdd) {
  if (!minutesToAdd) {
    return date;
  }

  var oldHours = date.getHours();
  var oldMinutes = date.getMinutes();
  var output = new Date(+date);
  output.setHours(oldHours, oldMinutes + minutesToAdd);
  return output;
}
/**
 * Returns the minimum time
 * @param {Date[]} times - array of date objects to looking for
 */

export function getMinTime(times) {
  var sortedArr = _toConsumableArray(times).sort(function (a, b) {
    return +a - +b;
  });

  return sortedArr[0];
}
/**
 * Returns the maximum time
 * @param {Date[]} times - array of date objects to looking for
 */

export function getMaxTime(times) {
  var sortedArr = _toConsumableArray(times).sort(function (a, b) {
    return +b - +a;
  });

  return sortedArr[0];
}
/**
 * Returns closes to now Date object with entered day of week
 * @param {number} weekDay
 */

export function getDayOfWeek(weekDay) {
  var date = new Date();
  var currentWeekDay = date.getDay();
  var delta = weekDay - currentWeekDay;
  date.setDate(date.getDate() + delta);
  return date;
}
/**
 * Returns the difference in minutes between two time strings
 * @param {string} timeString1
 * @param {string} timeString2
 */

export function getDifferenceInMinutes(timeString1, timeString2) {
  var parsed1 = parseTimeString(timeString1);
  var parsed2 = parseTimeString(timeString2);
  var minutes1 = 60 * parsed1[0] + parsed1[1];
  var minutes2 = 60 * parsed2[0] + parsed2[1];
  return minutes1 - minutes2;
}
/**
 * return time in ms from string format 2021-12-16T08:00:00
 * @param {string} str
 */

export function getTimeMsFromDateString(str) {
  var _str$split$;

  if (!str) {
    return 0;
  }

  var timeString = (_str$split$ = str.split('T')[1]) === null || _str$split$ === void 0 ? void 0 : _str$split$.split(':');

  if (!timeString) {
    return 0;
  }

  return (timeString[0] * 60 * 60 + timeString[1] * 60 + timeString[2]) * 1000;
}
export var getTimeInSec = function getTimeInSec(
/** @type {string} */
dateString) {
  if (!dateString) {
    return 0;
  }

  var time = dateString.split('T')[1].split(':');
  var output = +(time[2] || 0) + +(time[1] || 0) * 60 + +(time[0] || 0) * 3600;
  return output;
};